var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueTelInput',{class:{ 'input-error': _vm.hasError },attrs:{"value":_vm.formatedValue,"customValidate":_vm.customValidate,"validCharactersOnly":true,"inputOptions":{
    placeholder: _vm.placeholder,
    id: 'phone'
  },"dropdownOptions":{
    showDialCodeInSelection: true,
    showDialCodeInList: true,
    showFlags: true,
  },"default-country":_vm.formatedDefaultCountry},on:{"input":(number, details) => _vm.$emit('input', { number, details }),"country-changed":(country) => _vm.$emit('country-changed', country)}})
}
var staticRenderFns = []

export { render, staticRenderFns }